import type { ComponentType, ReactElement } from 'react';

export type GetLayout = (page: ReactElement) => JSX.Element;

export type WithLayoutProps = (
  Layout: ComponentType<{ children: ReactElement }>
) => GetLayout;

export const withLayout: WithLayoutProps = <
  TProps extends Record<string, unknown>,
>(
  Layout: ComponentType<{ children: ReactElement<TProps> }>
) =>
  function getLayout(page: ReactElement) {
    return (
      <Layout>
        {page}
      </Layout>
    );
  };
